// tslint:disable
export class UserFeedback {
  public name: string;
  public email: string;
  public event_id: string;
  public comments: string;
}
